/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Hero_Title_ConnectInputs */

const en_home_hero_title_connect = /** @type {(inputs: Home_Hero_Title_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect.`)
};

const es_home_hero_title_connect = /** @type {(inputs: Home_Hero_Title_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conecta.`)
};

const fr_home_hero_title_connect = /** @type {(inputs: Home_Hero_Title_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connectez.`)
};

const de_home_hero_title_connect = /** @type {(inputs: Home_Hero_Title_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verbinden.`)
};

const ja_home_hero_title_connect = /** @type {(inputs: Home_Hero_Title_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`繋がる。`)
};

const zh_home_hero_title_connect = /** @type {(inputs: Home_Hero_Title_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`连接。`)
};

const ar_home_hero_title_connect = /** @type {(inputs: Home_Hero_Title_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تواصل.`)
};

const id_home_hero_title_connect = /** @type {(inputs: Home_Hero_Title_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hubungkan.`)
};

const it_home_hero_title_connect = /** @type {(inputs: Home_Hero_Title_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connetti.`)
};

const ru_home_hero_title_connect = /** @type {(inputs: Home_Hero_Title_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Соединяй.`)
};

const pt_home_hero_title_connect = /** @type {(inputs: Home_Hero_Title_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conecte.`)
};

const ko_home_hero_title_connect = /** @type {(inputs: Home_Hero_Title_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`연결.`)
};

/**
* | output |
* | --- |
* | "Connect." |
*
* @param {Home_Hero_Title_ConnectInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const home_hero_title_connect = /** @type {((inputs?: Home_Hero_Title_ConnectInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Hero_Title_ConnectInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_hero_title_connect(inputs)
	if (locale === "es") return es_home_hero_title_connect(inputs)
	if (locale === "fr") return fr_home_hero_title_connect(inputs)
	if (locale === "de") return de_home_hero_title_connect(inputs)
	if (locale === "ja") return ja_home_hero_title_connect(inputs)
	if (locale === "zh") return zh_home_hero_title_connect(inputs)
	if (locale === "ar") return ar_home_hero_title_connect(inputs)
	if (locale === "id") return id_home_hero_title_connect(inputs)
	if (locale === "it") return it_home_hero_title_connect(inputs)
	if (locale === "ru") return ru_home_hero_title_connect(inputs)
	if (locale === "pt") return pt_home_hero_title_connect(inputs)
	return ko_home_hero_title_connect(inputs)
});